import React from 'react';
const Button = React.lazy(() => import('@material-ui/core/Button'));
import {StandartInput} from '@components/form/StandartInput';
import RemoteAutocompleteWithSearch from "@components/form/RemoteAutocompleteWithSearch";
import {NewCurrenciesContainer} from "@components/currencies/modals/new-currencies/new-currencies.container";
import {SimpleDialog} from "@components/form/SimpleDialog";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import Grid from "@material-ui/core/Grid";
import {LabelButton} from "@components/common/buttons/LabelButton";
import {TooltipButton} from "@components/common/buttons/TooltipButton";
const merge = require('deepmerge');
import clsx from "clsx";

export class NewProductPriceGroupComponent extends React.Component {
    initState = {
        form: {
            currency_id: "",
            title: "",
        },
        currency: null,
        errors: {}
    };
    state = {
        open: false,
        ...this.initState
    }

    async componentDidUpdate(prevState, prevProps) {
        if (this.props.productGroupId && this.state.open && this.state.open != prevProps.open) {
            const data = await this.props.getProductGroupDetails(this.props.productGroupId);
            let formData = {
                currency_id: data.data.currency.id,
                title: data.data.title,
            }
            this.setState({form: merge(this.state.form, formData)});
        } else if (this.state.open != prevProps.open) {
            this.setState(this.initState)
        }
    }

    updateProductGroup = async () => {
        let response = await this.props.updateProductGroup(
            this.props.productGroupId,
            this.state.form,
        );
        if (response.errors && Object.keys(response.errors).length) {
            this.setState({errors: response.errors});
        } else {
            if (response.data && response.data.id) {
                this.setState({open: false});
                if (this.props.tableRef)
                    this.props.tableRef.current.onQueryChange();
                else this.props.onSubmitRedirect(response.data);
            }
        }
    };

    onCurrencyCreate = (currency) => {
        this.setState({
            ...this.state,
            currency: {label: currency.code, value: currency.id},
            form: {
                ...this.state.form,
                currency_id: currency.id
            }
        })
    }

    render() {
        let { classes } = this.props;
        return (<SimpleDialog
                fullWidth={true}
                maxWidth={'sm'}
                open={this.state.open}
                onClose={(e) => this.setState({open: false})}
                title={ `${this.props.productGroupId ? 'Изменение существующей' : 'Добавление новой'}  группы цен` }
                icon={this.props.customOpenButton
                    ? <span onClick={(e) => this.setState({open: true})}>{this.props.customOpenButton}</span>
                    : this.props.productGroupId
                        ? <TooltipButton title="Редактировать"
                            icon={<EditOutlinedIcon color={'primary'} style={{marginLeft: 'auto'}} />}
                            onClick={(e) => this.setState({open: true})}
                        />
                        : <LabelButton
                            title={'Добавить группу цен'}
                            icon={<AddCircleRoundedIcon color={'primary'}/>}
                            onClick={(e) => this.setState({open: true})}
                            disableMargin
                        />
                }
                actions={[
                    (<Button
                        onClick={(e) => this.updateProductGroup()}
                        color="primary" variant="contained"
                    >
                        Сохранить
                    </Button>),
                ]}
            >
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12}>
                        <div className={classes.inputWithIconButton}>
                            <RemoteAutocompleteWithSearch
                                name={'currency_id'}
                                url={'/api/v1/autocomplete/currencies'}
                                value={this.state.form.currency ? this.state.form.currency.id : this.state.form.currency_id}
                                errors={this.state.errors}
                                label="Код валюты"
                                onChange={(e, {value}) => this.setState(merge(this.state, {form: {currency_id: value}}))}
                                disableClearable={true}
                                variant={'outlined'}
                                size={'small'}
                                margin={'normal'}
                                className={clsx([
                                    classes.input,
                                    classes.resetInputMarginTop,
                                ])}
                                objectValue={this.state.currency}
                            />

                            <NewCurrenciesContainer
                                customOpenButton={<AddCircleRoundedIcon
                                    className={classes.input_icon}
                                    style={{marginTop: 0}}
                                    color={'primary'}
                                />}
                                onSubmitRedirect={this.onCurrencyCreate}
                            />
                        </div>
                        <StandartInput
                            name={'title'}
                            value={this.state.form.title}
                            errors={this.state.errors}
                            label="Наименование"
                            onChange={({target: {value}}) => this.setState(merge(this.state, {form: {title: value}}))}
                            variant={'outlined'}
                            size={'small'}
                            margin={'normal'}
                            fullWidth
                            className={clsx([
                                classes.input,
                                classes.resetMarginBottom,
                            ])}
                        />
                    </Grid>
                </Grid>
            </SimpleDialog>
        );
    }
}
